export enum CheckoutDirectDebitMethod {
  AccountNumberSortCode = 'accountNumberSortCode',
  IBAN = 'iban',
}
